import type { ButtonProps, StackProps } from "@chakra-ui/react"
import AugmentationPanelFormActions, {
  type AugmentationPanelFormActionState
} from "@pathwright/ux/src/components/augmentation/AugmentationPanelFormActions"
import { useCoverPageTranslate } from "../utils"

type CoverPagePanelFormActionState = AugmentationPanelFormActionState

export type CoverPagePanelFormActionsProps = {
  stack?: StackProps
  form?: CoverPagePanelFormActionState
  disabled?: boolean
  requireDirty?: boolean
  submit?: ButtonProps
  discard?: ButtonProps
  /** Runs after the form is discarded, e.g. to leave a subpanel. */
  onDiscard?: () => void
  /** HTML form id so portaled submit still targets the panel form. */
  formId?: string
}

// Appears as a docked action bar on Cover Page panel form views.
export function CoverPagePanelFormActions({
  form,
  disabled = false,
  requireDirty = true,
  submit,
  discard,
  onDiscard,
  stack = {},
  formId
}: CoverPagePanelFormActionsProps) {
  const { t } = useCoverPageTranslate()
  const submitProps = submit || {
    children: t("panel.apply_changes", { defaultValue: "Apply changes" })
  }
  const discardProps = discard || {
    children: t("panel.discard_changes", { defaultValue: "Discard changes" })
  }
  return (
    <AugmentationPanelFormActions
      disabled={disabled}
      discard={discardProps}
      onDiscard={onDiscard}
      form={form}
      formId={formId}
      requireDirty={requireDirty}
      stack={stack}
      submit={submitProps}
    />
  )
}
